
<template>
  <div id="promise-pay">
    <el-dialog :close-on-click-modal="false" custom-class="lg-dialog promise-pay" append-to-body :visible="paymentVisible" :before-close="hideAdd.bind(null, { type: 'click' })" :title="$t('portal.bao-zheng-jin-shou-yin-tai')">
      <!-- 订单信息 -->
      <div class="lay-order">
        <h4 class="title"><i class="el-icon-circle-check"></i>{{$t('portal.qing-zhi-fu')}}</h4>
        <p class="total">{{$t('portal.ying-fu-jine')}}<span class="currency_sign">¥</span><span class="number">{{ formatMoney(paymentData.amount, true) }}</span>
        </p>
        <div class="order_des">
          <p>{{$t('portal.gong')}}{{paymentData.order_number}}{{$t('portal.bi-gua-pan-xiang')}}</p>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content">{{ paymentData.order_string }}</div>
            <p class="order_show">{{ paymentData.order_string }}</p>
          </el-tooltip>
        </div>
        <!-- 备注 -->
        <el-form class="lay-remark" :model="remarkForm" ref="remarkFormDom" label-width="60px">
          <el-form-item prop="remark" :label="$t('common.remark')">
            <el-input v-model="remarkForm.remark" type="textarea" size="small" :maxlength="200" resize="none" :autosize="{ minRows: 4 }" :placeholder="$t('portal.qing-shu-ru-200-zi-yi-nei')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 支付方式 -->
      <div class="lay-pay" v-loading="methodLoading">
        <h4 class="title">{{$t('portal.qing-xuan-ze-zhi-fu-fang-shi')}}</h4>
        <div class="pay_type">
          <div v-for="(item, key) in payType" :key="key" :class="item.active ? 'acitve' : ''" class="pay_type_item" :id="item.id" @click="changePayType(key)">
            <img :src="item.img" :alt="item.name">
          </div>
        </div>
        <div class="pay_message hxb" v-show="this.payTypeId === 'hxb'">
          <template v-if="isHxCard">
            <div class="card">
              <div class="card_box">
                <p class="account_name">{{$t('portal.hua-xia-zhang-hu')}}</p>
                <p class="card_name">{{ shopCardMessage.card_name }}</p>
                <p>{{ shopCardMessage.card_number }}</p>
              </div>
            </div>
            <div class="balance">
              <p class="amount">{{$t('portal.gong-si-ke-yong')}}：<span class="num">{{ formatMoney(haxiaCradMessage.icd_assets) }}</span>
              </p>
            </div>
            <div class="prompt_text">
              <p class="list">{{$t('portal.gong-si-yu-e-bu-zu')}}</p>
              <p class="list">{{$t('portal.hua-xia-yin-xing')}}</p>
            </div>
          </template>
          <template v-else>
            <div class="card card_not_open">
              <div class="card_box hxb_card">
                <p class="account_name">{{$t('portal.hua-xia-zhang-hu')}}</p>
                <p class="card_name"></p>
                <p>{{$t('portal.wei-kai-tong')}}</p>
              </div>
            </div>
            <p class="hxb_prompt">{{$t('portal.hua-xia-wei-kai-tong')}}</p>
          </template>
        </div>
      </div>
      <el-form class="lay-password" :model="passwordForm" ref="passwordFormDom" :rules="paymentRule" :show-message="false" label-width="90px" v-show="!payWithoutPassword">
        <el-form-item class="form-item-password" prop="password" :label="$t('login.password')">
          <el-input v-model="passwordForm.password" type="password" size="small" :maxlength="30" :placeholder="$t('portal.qing-shu-ru-zhi-fu-mi-ma')"></el-input>
          <span class="forget" @click="showVerifyDialog">{{$t('login.forget_password')}}</span>
          <p class="password_prompt">{{$t('portal.qing-shu-ru-nin-de-jiao-yi-zhang-bu-zhi-fu-mi-ma')}}</p>
        </el-form-item>
      </el-form>
      <!-- 底部按钮 -->
      <div class="lay-footer">
        <el-button class="btn-pay" type="primary" size="large" :disabled="isPaymentDisabled" @click="submitPayment" :loading="dataLoading">{{$t('portal.li-ji-zhi-fu')}}</el-button>
      </div>
      <!-- 忘记密码三弹窗 -->
      <getVerifyCode v-bind="forgetData.verifyData" @next="verifyPhoneOk" @hide="hideVerify"></getVerifyCode>
      <setPasswordDialog v-bind="forgetData.setNewData" @save="setNewPsd" @hide="hideSet"></setPasswordDialog>
      <resultDialog v-bind="forgetData.resultData" @hide="hideResult"></resultDialog>
    </el-dialog>
  </div>
</template>

<script>
import {translateI18n} from '~/common/utils/i18n-helper'
import { icFilters } from '~/common/plugins/ic-utils.js';
import { paymentRule, apiGetPaymentCardInfo, apiGetCardDetail, apiSetCardPassword } from '~/common/components/dialog/payDialog/config.js';
import BaseInfo from '~/common/components/detail/BaseInfo.vue';
import getVerifyCode from '~/common/components/setPassword/get_verify_code.vue';
import setPasswordDialog from '~/common/components/setPassword/set_password_dialog.vue';
import resultDialog from '~/common/components/setPassword/result_dialog.vue';
import HXB from '~/common/assets/img/pay1.png';
export default {
  name: 'PromisePay',
  components: {
    BaseInfo,
    getVerifyCode,
    setPasswordDialog,
    resultDialog
  },
  props: {
    paymentData: {
      type: Object,
      default: () => ({})
    },
    paymentVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      payWithoutPassword: false,
      //是否免密支付
      shopCardMessage: {},
      //佣金金卡信息
      shop_card_id: '',
      //佣金卡ID
      isHxCard: false,
      //是否存在华夏卡
      dataLoading: false,
      methodLoading: false,
      payType: [
      //暂时只有华夏支付
      {
        name: translateI18n('portal.hua-xia-yin-hang'),
        img: HXB,
        active: true,
        id: 'hxb'
      }],
      haxiaCradMessage: {
        icd_assets: 0
      },
      //华夏银行卡余额等信息
      payTypeId: 'hxb',
      //支付方式：微信、支付宝、华夏币
      passwordForm: {
        password: ''
      },
      paymentRule,
      remarkForm: {
        remark: ''
      },
      forgetData: {
        verifyData: {
          visible: false,
          title: translateI18n('portal.yan-zheng-ma-jiao-yan'),
          forgetPasswordData: {
            tel: '',
            verify_code: ''
          }
        },
        setNewData: {
          visible: false,
          title: translateI18n('portal.she-zhi-xin-mi-ma'),
          firstTime: false
        },
        resultData: {
          visible: false,
          title: translateI18n('portal.ti-shi'),
          resultType: '',
          content: '',
          customClassName: 'mini-dialog'
        }
      }
    };
  },
  computed: {
    // 多种情况决定支付是否可以点击
    isPaymentDisabled() {
      // loading中不能支付
      if (this.dataLoading || this.methodLoading || !this.isHxCard) return true;
      return false;
    }
  },
  watch: {
    paymentVisible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getCompanyAccountShop(this.paymentData.shop_id).then(data => {
            this.getCardInfo({
              card_type: 'commission',
              account_commission_id: data[0]?.id
            });
          });
          this.getPasswordCon({
            shop_id: this.paymentData.shop_id,
            shop_member_id: this.paymentData.shop_member_id
          });
          //this.getCardInfo({ card_type: 'commission', account_commission_id: this.paymentData.account_id });
        }
      }
    }
  },
  created() {},
  methods: {
    async getCompanyAccountShop(id) {
      //获取商户对应的做单公司
      const {
        code,
        msg,
        data = {}
      } = await this.$axios.$patch(`/rest/store/account/v3/account/company_account/shop/${id}`, {
        account_type: "shop"
      }).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      return data;
    },
    async getPasswordCon(param) {
      const {
        code,
        msg,
        data = {}
      } = await this.$axios.$post('/rest/store/hub/v3/payment/checkPasswordFree', param, {
        headers: {
          showNotify: false
        }
      }).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      if (code !== 200) return;
      this.payWithoutPassword = data.password_free;
    },
    async getHxCardOpen() {
      //获取华夏卡是否开通
      const {
        code,
        data,
        msg
      } = await this.$axios.$post('/rest/store/hub/v3/payment/hxb/bindCardInfo', {
        card_id: this.shop_card_id
      }, {
        headers: {
          showNotify: false
        }
      }).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) {
        this.isHxCard = false;
        return;
      }
      ;
      this.isHxCard = true;
    },
    async getCardDetail() {
      //获取华夏卡余额等信息
      const { code, data, msg } = await this.$axios
        .$post('/rest/store/hub/v3/payment/hxb/balanceQuery', { card_id: this.shop_card_id }, { headers: { showNotify: false } })
        .catch(() => ({ code: 40000, data: {}, msg: translateI18n('portal.fu-wu-chu-cuo') }));
      if (code !== 200) {
        // this.isHxCard = false;
        return;
      }
      this.isHxCard = true;
      this.haxiaCradMessage.icd_assets = data.available_assets;
    },
    changePayType(key) {
      this.payType.map((item, index) => {
        if (key === index) {
          this.payType[index].active = true;
        } else {
          this.payType[index].active = false;
        }
      });
      this.payTypeId = this.payType[key].id;
    },
    hideAdd(data) {
      this.$refs['passwordFormDom']?.resetFields();
      this.payTypeId = 'hxb';
      this.$emit('hide', data);
    },
    // 获取卡信息
    async getCardInfo(params) {
      this.methodLoading = true;
      const {
        code,
        msg,
        data
      } = await this.$axios.$post(apiGetPaymentCardInfo, params).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      this.methodLoading = false;
      if (code !== 200) return;
      this.shop_card_id = data.card_id;
      this.shopCardMessage = data;
      this.getHxCardOpen();
      this.getCardDetail(); //获取华夏卡余额等信息
    },
    // 金额格式处理
    formatMoney(value = 0, noSymbol = false) {
      if (value === 0) {
        return '0';
      }
      return icFilters.formatMoney(value, null, 4, null, noSymbol, '', 2);
    },
    // 保留小数位数
    remainPointNumber(value, num) {
      let arr = (value + '').split('.');
      if (arr[1]) {
        return `${arr[0]}.${arr[1].substring(0, num)}` - 0;
      } else {
        return value;
      }
    },
    // 点击忘记密码，弹出验证码框
    async showVerifyDialog() {
      const {
        code,
        data,
        msg
      } = await this.$axios.$get(apiGetCardDetail).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) return;
      // 手机号取值需要处理一下，截掉前面的区号和空格
      const {
        registeredCellphone = ''
      } = data || {};
      const arrPhone = registeredCellphone.toString().split(' ');
      const lastPhone = typeof arrPhone[1] === 'undefined' ? arrPhone[0] : arrPhone[1];
      if (!lastPhone) {
        return this.$message.warning({
          message: translateI18n('portal.zhao-hui-mi-ma')
        });
      }
      Object.assign(this.forgetData.verifyData, {
        visible: true,
        forgetPasswordData: {
          tel: lastPhone,
          verify_code: ''
        }
      });
    },
    // 隐藏验证码校验弹窗
    hideVerify() {
      Object.assign(this.forgetData.verifyData, {
        visible: false
      });
    },
    // 显示设置密码弹窗
    verifyPhoneOk() {
      this.hideVerify();
      Object.assign(this.forgetData.setNewData, {
        visible: true
      });
    },
    // 隐藏设置密码弹窗
    hideSet() {
      Object.assign(this.forgetData.setNewData, {
        visible: false
      });
    },
    // 设置支付密码
    async setNewPsd({
      new_password
    }, okCallback) {
      const {
        code,
        data,
        msg
      } = await this.$axios.$post(apiSetCardPassword, {
        id: this.shopCardMessage.card_id,
        new_password
      }).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) return;
      okCallback();
      Object.assign(this.forgetData.resultData, {
        visible: true,
        resultType: 'success',
        content: translateI18n('portal.mi-ma-she-zhi-cheng-gong')
      });
    },
    // 隐藏修改结果提示弹窗
    hideResult() {
      Object.assign(this.forgetData.resultData, {
        visible: false
      });
    },
    // 选择“华夏银行支付”
    async submitPayment() {
      const {
        card_id
      } = this.shopCardMessage || {};
      const {
        icd_assets = 0
      } = this.haxiaCradMessage;
      // 华夏银行需要查到支付卡信息才能支付
      if (!card_id) {
        return this.$message.warning(translateI18n('portal.wu-fa-zhi-fu'));
      }
      if (icd_assets < 0) {
        return this.$message.warning(translateI18n('portal.mei-you-ke-yong-yu-e'));
      }
      if (this.haxiaCradMessage.icd_assets < this.paymentData.amount) {
        return this.$message.warning(translateI18n('portal.gong-si-hua-xia-zhang-hu-ke-yong-yuebu-zu'));
      }
      const validatePassword = await this.$refs.passwordFormDom.validate().catch(() => false);
      if (!this.payWithoutPassword && !validatePassword) {
        return this.$message.warning(translateI18n('portal.zheng-que-mi-ma'));
      }
      // 通过表单校验后，处理请求参数，调用支付接口
      let {
        account_id,
        amount,
        deposit_type,
        order_code,
        shop_id,
        shop_member_id,
        order_string
      } = this.paymentData;
      const params = {
        amount: amount / 10000,
        account_id,
        deposit_type,
        description: order_string + '。' + this.remarkForm.remark,
        order_code,
        password: this.passwordForm.password === '' ? undefined : this.passwordForm.password,
        payment_type: 'hxb',
        shop_id,
        shop_member_id,
        unique_id: +new Date() + '' //去重唯一标识
      };
      this.requestPayment(params);
    },
    // 将最终支付函数抽离出来
    async requestPayment(params) {
      this.dataLoading = true;
      const { code, data, msg } = await this.$axios.$post('/rest/store/hub/v3/payment/hxb/marginFreeze', params).catch(() => ({ code: 40000, data: {}, msg: translateI18n('portal.fu-wu-chu-cuo') }));
      this.dataLoading = false;
      // 关闭当前弹窗,通知父组件
      this.hideAdd({
        type: 'api',
        ...data,
        code
      });
    }
  }
};
</script>

<style lang="less">
.promise-pay {
  top: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  .el-dialog__body {
    padding: 0;
  }
  #tab-wallet,
  #tab-online,
  #tab-offline {
    width: 120px;
    text-align: center;
  }
  .hxb {
    display: flex;
    align-items: center;
    cursor: default;
    margin: 0 40px 10px 0;
    padding: 10px 0;
    flex-wrap: wrap;
    .card {
      display: flex;
      flex: 2;
      color: @fc6;
      margin-right: 10px;
      flex-direction: column;
      .card_box {
        color: #ffffff;
        width: 180px;
        height: 90px;
        background-image: url(~/common/assets/img/bg_card_hxb.png);
        background-repeat: no-repeat;
        padding: 10px 14px;
      }
      .card_name {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 2px;
      }
      .logo {
        width: 14px;
        margin-right: 5px;
      }
    }
    .card_not_open.card {
      flex: initial;
      margin-right: 30px;
    }
    .balance {
      display: flex;
      flex: 5;
      align-items: center;
      .lay-balance {
        margin-right: 10px;
        flex: 1;
      }
    }
    .credit {
      display: flex;
      flex: 1;
      align-items: center;
      color: @fc6;
      .amount {
        color: #c0c4cc;
      }
    }
    .prompt_text {
      flex-basis: 100%;
      margin-top: 10px;
    }
  }
  .base-info .el-col .u-val.money {
    color: #ff4d4d;
  }
  overflow: auto;
  .el-loading-mask {
    border: none;
  }
  .base-info .el-col .u-label {
    text-decoration: none;
    padding-right: 0;
  }
  .lay-order {
    position: relative;
    .order_des {
      .order_show {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.5;
        width: fit-content;
      }
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 4px !important;
      .el-icon-circle-check {
        color: #67c23a;
        font-size: 20px;
        margin-right: 6px;
      }
    }
    .total {
      position: absolute;
      top: 7px;
      right: 40px;
      color: #3f3f3f;
      .currency_sign,
      .number {
        color: #ea5728;
        font-size: 20px;
      }
      .number {
        font-weight: 700;
        margin-left: 6px;
      }
    }
  }
  .lay-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 10px;
    border-bottom: 1px solid #efefef;
    .title {
      font-size: 16px;
    }
    .back {
      cursor: pointer;
    }
  }
  .lay-order,
  .lay-pay,
  .lay-remark,
  .lay-password {
    padding: 20px 40px;
    border-bottom: 1px solid #efefef;
    .title {
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 28px;
      color: #3f3f3f;
    }
    .password_prompt {
      color: #f56c6c;
      line-height: initial;
      margin-top: 5px;
    }
  }
  .lay-password {
    margin-left: -5px;
    border-bottom: none;
  }
  .lay-order {
    .title {
      margin-left: -27px;
    }
    .base-info .el-col .u-label {
      text-decoration: none;
    }
    .custom-style {
      margin-bottom: 5px;
    }
  }
  .lay-pay {
    border-bottom: none;
    .pay_message {
      border-bottom: 1px solid #efefef;
    }
    .pay_type {
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid #efefef;
      font-size: 0;
      .pay_type_item {
        border: 1px solid #dcdfe6;
        cursor: pointer;
        margin-right: 30px;
        padding: 4px 20px;
      }
      #XinPay {
        padding-top: 5px;
      }
      .pay_type_item.acitve {
        position: relative;
        border: 1px solid #ea5728;
      }
      .pay_type_item.acitve::after {
        content: url(~/common/assets/img/select.png);
        position: absolute;
        top: 0;
        right: -1px;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item.form-item-balance {
      margin-right: 10px;
      .el-input {
        min-width: 110px;
      }
    }
    .el-tabs__header {
      margin-bottom: 10px;
    }
    .el-tabs__content {
      padding: 0 5px;
    }
    .name {
      width: 130px;
    }
    .amount {
      flex: 2;
      margin-right: 40px;
      .num {
        color: #ea5728;
      }
    }
    .offline-item {
      line-height: 36px;
      color: #626262;
    }
    .offline-tip {
      line-height: 34px;
      color: #9e9e9e;
    }
  }
  .lay-password {
    .form-item-password {
      margin-bottom: 0;
      .el-form-item__label {
        font-size: 15px;
        color: #3f3f3f;
      }
      .el-input {
        width: auto;
      }
      .el-input__inner {
        width: 200px;
      }
    }
    .forget {
      margin-left: 3px;
      color: #3487dd;
      cursor: pointer;
    }
  }
  .lay-remark {
    padding-left: 0 !important;
    margin-left: -5px;
    border: none;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .lay-footer {
    padding: 15px 0 20px;
    text-align: center;
    .btn-pay {
      width: 200px;
    }
  }
}
@media screen and (max-width: 1360px) {
  .order-payment {
    .hxb {
      .card {
        .card_box {
          width: 90%;
        }
      }
    }
  }
}
</style>
